import {axiosInstance} from '@/plugins/axios'
export default (axios=axiosInstance) => ({
    getProducts(page='',sortby='',category='',brands='',limit,sponsor,search,min=0,max=10000) {
      return axios.get(`/products?sort_by=${sortby}&${category}&brands=${brands}&limit=${limit}&sponsor=${sponsor}&price[min]=${min}&search=${search}&price[max]=${max}&page=${page}`);
    },
    getProductsByCategory(category='',limit=10,sortby='') {
      return axios.get(`/products?categories=${category}&limit&${limit}&sort_by=${sortby}`);
    },
    getProductsByCategorySlug(slug='',limit=10,sortby='') {
      return axios.get(`/products?category_slug=${slug}&limit&${limit}&sort_by=${sortby}`);
    },
    getProductByCommaSeparation(id) {
      return axios.get(`/products/poduct-item/${id}`);
    },
getProduct(page=1,id){
return axios.get(process.env.VUE_APP_BASE_API_URL+`/products/${id}?page=${page}`);
},
    getsearchProducts(query, limit){
      return axios.get(`/products`, {
        params: {
          search: query,
          limit: limit,
        },
      });
    }
  });
  